import React, { useState } from 'react'

//Dependencies.
import { Col, Container, Row, Tooltip } from 'reactstrap';

//Images.
import personalPage from "../../../images/instructionImages/homePage.png";
import whereToAddVideos from "../../../images/instructionImages/whereToAddVideos.png";
import challengeFormImage from "../../../images/instructionImages/ChallengeForm.png";
import submitVideoImage from "../../../images/instructionImages/addYourVideosToAChallengeAnnouncement.png";
import announcementBox from "../../../images/instructionImages/chalengeAnnouncementsView_i.jpg";
import allAnnouncements from "../../../images/instructionImages/challengeAnnoncementsView_ii.png";

import "./Instructions.styles.css";


const Instructions = () => {
  const [toolTipOpen, setToolTipOpen] = useState(false);
  const [addVideoOpen, setAddVideoOpen] = useState(false);
  const [createChallengeTooltip, setCreateChallengeTooltip] = useState(false);
  const [submitVideoTooltipOpen, setSubmitVideoTooltipOpen] = useState(false);
  const [challengeAnnouncementsToolTip, setChallengeAnnouncementsToolTip] = useState(false)

  const toggle = () => setToolTipOpen(!toolTipOpen);
  const toggleAddVideo = () => setAddVideoOpen(!addVideoOpen);
  const toggleCreateChallengeTooltip = () => setCreateChallengeTooltip(!createChallengeTooltip);
  const toggleSubmitVideoToolTipOpen = () => setSubmitVideoTooltipOpen(!submitVideoTooltipOpen);
  const toggleChallengeAnnouncementToolTipOpen = () => setChallengeAnnouncementsToolTip(!challengeAnnouncementsToolTip);


  return (
    <Container className='p-5'>
      <Row className='p-3'>
        <Col style={{ textAlign: 'center' }}>
          <h1 style={{color: 'firebrick'}}>Create Your Very Own <em>Interactive</em> Talent Contest!</h1>
        </Col>
      </Row>
      <Row>
        <Col style={{ display: 'flex', justifyContent: 'space-between' }}>
          <ul>
            <li><h5>Put your voice up against your friends, other members in this site... or even a <em>famous celebrity</em> (no kidding)!</h5></li>
            <li><h5>How about put one celebrity singer up against another and have the Internet Idol community vote to see who has the best voice!</h5></li>
            <li><h5>Why stop at best voice? How about see who is the best dancer, musician, etc...!</h5></li>
            <li><h5>Let the Internet Idol <em>community</em> <span className='text-danger'>vote</span> for the best singer (or dancer... or whatever)!!!</h5></li>
          </ul>
        </Col>
      </Row>
      <Row>
        <Col style={{ textAlign: 'center' }}>
          <h3 className='text-danger'>Here's How It Works...</h3>
        </Col>
      </Row>
      <ol style={{fontWeight: 'bolder'}}>
        <li> If you haven't already done so, sign up! </li>
        <li>
          After signing up, you will be directed to your <em className='text-danger' id='personalHomePage'> personal home page.</em>
          <Tooltip isOpen={toolTipOpen} toggle={toggle} placement='right' target="personalHomePage">
            <strong>Here is how your home page looks like:</strong>
            <div style={{ width: '100%', height: 'auto' }}>
              <img src={personalPage} className='img-fluid' alt='persona page img.' />
            </div>
          </Tooltip>
        </li>
        <li>
          Once you are in your home page, <span className="text-danger" id="addVideos">add a few videos</span> either of yourself singing or or another celebrity (such as a celebrity on You-Tube). <span className='text-danger'>IMPORTANT:</span>In order to create a challenge (i.e. a contest), you must first have videos.
          <Tooltip isOpen={addVideoOpen} toggle={toggleAddVideo} placement='right' target='addVideos'>
            <strong>Click 'Add New Video' & you will be directed to a form to add a new video.</strong>
            <div style={{ width: '100%', height: 'auto' }}>
              <img src={whereToAddVideos} className='img-fluid' alt='where to add videos.' />
            </div>
          </Tooltip>
        </li>
        <li>
          After you are done uploading the videos, you may now <span id='createChallenge' className='text-danger'>create your challenge</span>!
          <Tooltip isOpen={createChallengeTooltip} toggle={toggleCreateChallengeTooltip} placement='right' target="createChallenge">
            <strong>The form to create your challenge.</strong>
            <div style={{ width: '100%', height: 'auto' }}>
              <img src={challengeFormImage} className='img-fluid' alt='challenge form img..' />
            </div>
          </Tooltip>
        </li>
        <li>
          As you create your challenge, you will be given an option to create an <em>announcement</em>. This is similar to an advertisement in a newspaper to let others know about your challenge as well as to give them an opportunity to <span id='submitYourVideo' className='text-danger'>submit their videos to your challenge</span>!
          <Tooltip isOpen={submitVideoTooltipOpen} toggle={toggleSubmitVideoToolTipOpen} placement='right' target="submitYourVideo">
            <strong>Where to submit your video(s):</strong>
            <div style={{ width: '100%', height: 'auto' }}>
              <img src={submitVideoImage} className='img-fluid' alt='Where to submit your video' />
            </div>            
          </Tooltip>
        </li>
        <li>
          <em>Speaking of submitting videos...</em> you can also submit your videos to other <span id="announcements" className='text-danger'>challenge announcements</span>! Put your video up against theirs!!!
          <Tooltip isOpen={challengeAnnouncementsToolTip} toggle={toggleChallengeAnnouncementToolTipOpen} placement='right' target="announcements">
            <strong>Click here to view all <em>ANNOUNCEMENTS</em>...</strong>
            <div style={{ width: '100%', height: 'auto' }}>
              <img src={announcementBox} alt='img. of the announcement box.' className='img-fluid' />
            </div>
            <strong>If there are any current announcements, it will display here.</strong>
            <div style={{ width: '100%', height: 'auto' }}>
              <img src={allAnnouncements} alt='all challenge announcements' className='img-fluid' />
            </div>
            <strong>Just click the one that interests you and you can join inside the page for <em>that challenge</em>!!!</strong>
          </Tooltip>
        </li>
        <li>
          A challenge ends either when the deadline has been met OR when a video receives a pre-determined amount of winning votes.
        </li>
        <li>
          Each video's record will be logged and kept!
        </li>
      </ol>
    </Container>
  )
}

export default Instructions